"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require(".");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  list: {
    path: 'dashboard',
    icon: 'show_chart',
    title: 'Dashboard',
    private: true,
    level: 0,
    restricted: 'control.analytics',
    component: props => /*#__PURE__*/_react.default.createElement(_.CustomAnalytics, null)
  }
};
module.exports = exports.default;